const OurStorySection = () => {
  return (
    <div className="py-20 px-4">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            Our Approach
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Our methodology combines cutting-edge technology with human compassion for personalized solutions.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-8">
          <div className="space-y-8">
            <div className="bg-card rounded-md p-8 shadow-raised hover:shadow-floating transition-shadow">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-3 h-8 bg-primary rounded-full"></div>
                <h3 className="text-2xl font-bold text-foreground">
                  Home Safety Checks
                </h3>
              </div>
              <p className="text-muted-foreground leading-relaxed text-lg">
                Home Safety Checks analyzes your home environment to identify risks before problems occur. 
                No wearables required, just upload photos for actionable safety insights.
              </p>
            </div>
            
            <div className="bg-card rounded-md p-8 shadow-raised hover:shadow-floating transition-shadow">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-3 h-8 bg-primary rounded-full"></div>
                <h3 className="text-2xl font-bold text-foreground">
                  Personalized Guidance
                </h3>
              </div>
              <p className="text-muted-foreground leading-relaxed text-lg">
                Every recommendation is tailored to your specific needs and living situation. 
                DIY solutions, product recommendations, and local providers that fit your lifestyle.
              </p>
            </div>
          </div>
          
          <div className="space-y-8">
            <div className="bg-card rounded-md p-8 shadow-raised hover:shadow-floating transition-shadow">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-3 h-8 bg-primary rounded-full"></div>
                <h3 className="text-2xl font-bold text-foreground">
                  Family-Centered Design
                </h3>
              </div>
              <p className="text-muted-foreground leading-relaxed text-lg">
                Independence doesn't mean isolation. Our platform strengthens family bonds 
                while respecting autonomy through coordinated care tools and shared insights.
              </p>
            </div>
            
            <div className="bg-card rounded-md p-8 shadow-raised hover:shadow-floating transition-shadow">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-3 h-8 bg-primary rounded-full"></div>
                <h3 className="text-2xl font-bold text-foreground">
                  Empowering Communication
                </h3>
              </div>
              <p className="text-muted-foreground leading-relaxed text-lg">
                We communicate with warmth, empathy, and respect, never talking down. 
                Every interaction builds confidence and motivates positive action.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurStorySection;